function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { ButtonIconAddWithText } from '@arc/frontend/ui-buttons';
import { su, theme, typography } from '@arc/frontend/ui-theme';
import { AddMenu } from './AddMenu';
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "1ab24og",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:20rem"
  } : {
    name: "bdg8r3-container",
    styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:20rem;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  icon: /*#__PURE__*/css({
    width: '100%',
    height: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '2rem',
    maxWidth: '6.5rem',
    maxHeight: '6.5rem',
    color: theme.colors.text.hint
  }, process.env.NODE_ENV === "production" ? "" : ";label:icon;"),
  message: /*#__PURE__*/css(typography.emptyLarge, "text-align:center;max-width:40rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:message;")),
  // font is heavier to make lighter text more visible
  missingPerm: /*#__PURE__*/css({
    color: theme.colors.text.permission,
    fontWeight: '400'
  }, process.env.NODE_ENV === "production" ? "" : ";label:missingPerm;"),
  addButton: /*#__PURE__*/css(typography.clickableLink, su.textMd, {
    color: theme.colors.text.tableHeader,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '2.5rem',
    paddingRight: '2.5rem',
    paddingTop: '0.75rem',
    paddingBottom: '0.75rem',
    cursor: 'pointer'
  }, process.env.NODE_ENV === "production" ? "" : ";label:addButton;"),
  addButtonIcon: process.env.NODE_ENV === "production" ? {
    name: "k4bazs",
    styles: "width:1.25rem;height:1.25rem;margin-left:0.5rem"
  } : {
    name: "10d0jc5-addButtonIcon",
    styles: "width:1.25rem;height:1.25rem;margin-left:0.5rem;label:addButtonIcon;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
export function EmptySection(props) {
  return <div css={[styles.container, props.outerStyle, process.env.NODE_ENV === "production" ? "" : ";label:EmptySection;"]} data-testid="empty-section">
			<props.Icon css={[styles.icon, props.iconStyle, props.missingPermission && styles.missingPerm, process.env.NODE_ENV === "production" ? "" : ";label:EmptySection;"]} />
			{props.message ? <div css={[styles.message, props.messageStyle, props.missingPermission && styles.missingPerm, process.env.NODE_ENV === "production" ? "" : ";label:EmptySection;"]}>
					{props.message}
				</div> : null}
			{props.onAddClick ? <ButtonIconAddWithText side="left" text={props.addText} buttonStyle={styles.addButton} onClick={props.onAddClick} /> : null}
			{props.addOptions ? <AddMenu addOptions={props.addOptions} label={props.addText} addButtonStyles={styles.addButton} buttonIconStyles={styles.addButtonIcon} listTestid="empty-section-add-list" /> : null}
		</div>;
}